export default __webpack_public_path__ + "static/media/7c0771e5d7a0d19c935fd501fd1e21ce1576084661271.15b6621c.webp";